import { Card, LabelledList, Stack, Text, TitleGroup } from '@ekhodealer/ekho-common/rev';

import type { LabelledListItem } from '@ekhodealer/ekho-common/rev';

import { onboardingContent, OnboardingPage } from './content';

export function PricingValuePage() {
	const pageContent = onboardingContent[OnboardingPage.PricingValue];

	const pricingValuePoints: LabelledListItem[] = [
		{
			iconType: 'address',
			content: (
				<Stack itemsSpacing='4'>
					<Text size='body' weight='bold'>
						No overhead on sales processing
					</Text>
					<Text size='bodySmall' color='secondary'>
						Financing, insurance, fraud protection, taxes, titling, and registration are
						fully managed by Ekho. Your team stays focused on what they do best.
					</Text>
				</Stack>
			),
		},
		{
			iconType: 'phone',
			content: (
				<Stack itemsSpacing='4'>
					<Text size='body' weight='bold'>
						Incremental sales
					</Text>
					<Text size='bodySmall' color='secondary'>
						Reach online buyers who wouldn&apos;t have visited the dealership — a
						younger, more diverse audience.
					</Text>
				</Stack>
			),
		},
		{
			iconType: 'email',
			content: (
				<Stack itemsSpacing='4'>
					<Text size='body' weight='bold'>
						24/7 dealership, national coverage
					</Text>
					<Text size='bodySmall' color='secondary'>
						Convert online traffic after hours and sell into all 50 states with built-in
						compliance.
					</Text>
				</Stack>
			),
		},
		{
			iconType: 'hours',
			content: (
				<Stack itemsSpacing='4'>
					<Text size='body' weight='bold'>
						2X your customer experience
					</Text>
					<Text size='bodySmall' color='secondary'>
						Ekho&apos;s average NPS is 2X the traditional dealer experience.
					</Text>
				</Stack>
			),
		},
		{
			iconType: 'hours',
			content: (
				<Stack itemsSpacing='4'>
					<Text size='body' weight='bold'>
						Maintain margins with embedded upsells
					</Text>
					<Text size='bodySmall' color='secondary'>
						Ekho upsells accessories and backend products at checkout. Earn a portion of
						F&I and dealer reserve revenue.
					</Text>
				</Stack>
			),
		},
	];

	return (
		<Stack itemsSpacing='24'>
			<TitleGroup
				title={pageContent.pageTitle}
				description={pageContent.subtitle}
				level='page'
				variant='centered'
				maxWidth='640px'
			/>

			<Card>
				<LabelledList items={pricingValuePoints} variant='icon' />
			</Card>
		</Stack>
	);
}
